import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ConfirmModalComponent } from '@crdigital/crdigital-ui-sdk';
import { ConfirmModalModel } from '@crdigital/crdigital-ui-sdk';

@Injectable({
  providedIn: 'root',
})
export class PendingChangesService {
  userIsEditing: BehaviorSubject<any> = new BehaviorSubject(false);
  userIsEditing$: Observable<boolean> = this.userIsEditing.asObservable();

  save: Subject<any> = new Subject();
  save$: Observable<any> = this.save.asObservable();

  changeTab: Subject<number> = new Subject();
  changeTab$: Observable<number> = this.changeTab.asObservable();

  changeRoute: Subject<string> = new Subject();
  changeRoute$: Observable<string> = this.changeRoute.asObservable();

  cancelUpload: Subject<any> = new Subject();
  cancelUpload$: Observable<boolean> = this.cancelUpload.asObservable();

  constructor(private dialog: MatDialog) { }

  openConfirmModal(confirmModalModel: ConfirmModalModel): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '95vw';
    dialogConfig.maxWidth = '600px';
    dialogConfig.data = confirmModalModel;
    return this.dialog.open(ConfirmModalComponent, dialogConfig).afterClosed();
  }
}
